<template>
  <div>
    <a-fromRowLable
      v-if="value == 1"
      :title="title"
      value="ذكر"
    ></a-fromRowLable>
    <a-fromRowLable v-else :title="title" value="انثي"></a-fromRowLable>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    value: String,
  },
};
</script>
